import { createSelector } from '@reduxjs/toolkit';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { LocationType } from 'commons/src/models/commonTypeScript';
import { CustomThreshold } from '../../../models/thresholdModels';
import { Store } from '../../../reducers';

const selectLocations = (state: Store): LocationType[] => state.locations.locations;

export const locationCustomThresholdSelector = createSelector([selectLocations], (locations): CustomThreshold[] => {
    const validSensorKeys = Object.values(SensorTypes);

    return locations.reduce<CustomThreshold[]>((acc, location) => {
        const { customThresholds } = location;
        if (!customThresholds) return acc;

        const sensors = Object.keys(customThresholds).filter(
            (key): key is SensorTypes =>
                validSensorKeys.includes(key as SensorTypes) &&
                Array.isArray(customThresholds[key as SensorTypes]?.thresholds) &&
                customThresholds[key as SensorTypes]?.thresholds.length > 0
        );

        if (sensors.length > 0) {
            acc.push({
                name: location.name,
                id: location.id,
                sensors,
            });
        }

        return acc;
    }, []);
});

export default locationCustomThresholdSelector;
